/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `English` - ENGLISH
 * * `Mandarin Chinese` - MANDARIN_CHINESE
 * * `Hindi` - HINDI
 * * `Spanish` - SPANISH
 * * `Arabic` - ARABIC
 * * `French` - FRENCH
 * * `Bengali` - BENGALI
 * * `Russian` - RUSSIAN
 * * `Portuguese` - PORTUGUESE
 * * `Swahili` - SWAHILI
 * * `Indonesian` - INDONESIAN
 * * `Urdu` - URDU
 * * `Japanese` - JAPANESE
 * * `German` - GERMAN
 * * `Punjabi` - PUNJABI
 * * `Farsi/Persian` - FARSI_PERSIAN
 * * `Javanese` - JAVANESE
 * * `Wu Chinese` - WU_CHINESE
 * * `Vietnamese` - VIETNAMESE
 * * `Italian` - ITALIAN
 * * `Turkish` - TURKISH
 * * `Marathi` - MARATHI
 * * `Telugu` - TELUGU
 * * `Tamil` - TAMIL
 * * `Korean` - KOREAN
 * * `Jin Chinese` - JIN_CHINESE
 * * `Hausa` - HAUSA
 * * `Thai` - THAI
 * * `Yue Chinese/Cantonese` - YUE_CHINESE_CANTONESE
 * * `Gujarati` - GUJARATI
 * * `Bhojpuri` - BHOJPURI
 */
export enum Language {
  ENGLISH = 'English',
  MANDARIN_CHINESE = 'Mandarin Chinese',
  HINDI = 'Hindi',
  SPANISH = 'Spanish',
  ARABIC = 'Arabic',
  FRENCH = 'French',
  BENGALI = 'Bengali',
  RUSSIAN = 'Russian',
  PORTUGUESE = 'Portuguese',
  SWAHILI = 'Swahili',
  INDONESIAN = 'Indonesian',
  URDU = 'Urdu',
  JAPANESE = 'Japanese',
  GERMAN = 'German',
  PUNJABI = 'Punjabi',
  FARSI_PERSIAN = 'Farsi/Persian',
  JAVANESE = 'Javanese',
  WU_CHINESE = 'Wu Chinese',
  VIETNAMESE = 'Vietnamese',
  ITALIAN = 'Italian',
  TURKISH = 'Turkish',
  MARATHI = 'Marathi',
  TELUGU = 'Telugu',
  TAMIL = 'Tamil',
  KOREAN = 'Korean',
  JIN_CHINESE = 'Jin Chinese',
  HAUSA = 'Hausa',
  THAI = 'Thai',
  YUE_CHINESE_CANTONESE = 'Yue Chinese/Cantonese',
  GUJARATI = 'Gujarati',
  BHOJPURI = 'Bhojpuri',
}
